import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'

export function EPlanUploadCard({
  onSelectFromSources,
  onUpload,
}: {
  onSelectFromSources: () => void
  onUpload: () => void
}) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('settings.ePlan.assignFlow.uploadTitle')}</CardTitle>
        <CardDescription>
          {t('settings.ePlan.assignFlow.uploadDescription')}
        </CardDescription>
      </CardHeader>
      <CardContent className='space-y-3'>
        <div className='flex flex-wrap gap-2'>
          <Button
            type='button'
            variant='outline'
            size='sm'
            onClick={onSelectFromSources}
          >
            {t('settings.ePlan.assignFlow.selectFromSources')}
          </Button>
          <Button type='button' variant='outline' size='sm' onClick={onUpload}>
            {t('settings.ePlan.assignFlow.upload')}
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
